import { Subject } from 'rxjs';

const subject = new Subject();

export default {
  show: (video) => subject.next({ video }),
  hidden: () => subject.next(null),
  getVideo: () => subject.asObservable(),
};
